import { CSSProperties, memo } from 'react';
import { KContainer, KGrid, KImage, KLabel, KLoading, MIcon } from 'uikit';

interface IProps {
  icon: MIcon;
  iconStyle: CSSProperties;
  label: string;
  value: number | string;
  isLoading?: boolean;
}

const TotalCard = ({
  icon,
  iconStyle,
  label,
  value = 0,
  isLoading = false
}: IProps) => {
  return (
    <KContainer.View
      padding="1rem"
      position="relative"
      style={{
        border: '1px solid #ccc',
        borderRadius: '1rem',
        background: '#fff'
      }}
    >
      {isLoading && <KLoading />}
      <KGrid.Container spacing={2}>
        <KGrid.Item xs={4}>
          <KImage.MuiIcon icon={icon} style={iconStyle} />
        </KGrid.Item>
        <KGrid.Item xs={8}>
          <KGrid.Container spacing={2}>
            <KGrid.Item xs={12}>
              <KContainer.View
                style={{ marginLeft: 'auto' }}
                row
                alignItems
                marginL="1rem"
              >
                <KLabel.Text marginR="2rem" typo="TextMdNormal">
                  {label}
                </KLabel.Text>
              </KContainer.View>
            </KGrid.Item>
            <KGrid.Item xs={12}>
              <KContainer.View style={{ marginLeft: 'auto' }} row alignItems>
                <KLabel.Text marginL="2rem" typo="TextXLgBold">
                  {value}
                </KLabel.Text>
              </KContainer.View>
            </KGrid.Item>
          </KGrid.Container>
        </KGrid.Item>
      </KGrid.Container>
    </KContainer.View>
  );
};

export default memo(TotalCard);
